import { arrayOf, number } from 'prop-types';
import React, { memo } from 'react';

function Dot({
  coordinates: [ y, x ],
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1"
      height="1"
      x={x}
      y={y}
    >
      <circle opacity="0.3" cx="12" cy="12" r="2" fill="#fff" />
    </svg>
  );
}

Dot.propTypes = {
  coordinates: arrayOf(number),
};

export default memo(Dot);
